<template>
  <modal :name="modalName" transition="fade" top="0" width="700" height="auto" draggable="true"
    @before-open="beforeOpen" :adaptive="true">
    <div class="modal-container">
      <div class="modal-header">
        <h3>Create Vehicle</h3>
        <button @click=close>X</button>
      </div>
      <div class="modal-content">
        <div class="modal-intro-information">
          <p>All vehicles need to be associated to a user for this community. Please add all required vehicle
            information</p>
        </div>
        <div class="modal-create-data">
          <div class="modal-create-data-item">
            <p>Unit*</p>
            <div>
              <div v-if="showTypes">
                <ul @mouseleave="showTypes = false">
                  <li v-for="type in types" :key="type" @click="setType(type)">
                    {{ type }}
                  </li>
                </ul>
              </div>
              <button v-else ref="type" @click="showTypes = !showTypes"> {{ selectedType }}</button>
            </div>
          </div>
          <div class="modal-create-data-item">
            <p>Vehicle Make*</p>
            <div>
              <div v-if="showStatuses">
                <ul @mouseleave="showStatuses = false">
                  <li v-for="status in statuses" :key="status" @click="setStatus(status)">
                    {{ status }}
                  </li>
                </ul>
              </div>
              <button v-else ref="status" @click="showStatuses = !showStatuses"> {{ selectedStatus }}</button>
            </div>
          </div>
          <div class="modal-create-data-item">
            <p>Vehicle Model*</p>
            <div>
              <div v-if="showLocations">
                <ul @mouseleave="showLocations = false">
                  <li v-for="location in locations" :key="location" @click="setLocation(location.location_name)">
                    {{ location.location_name }}
                  </li>
                </ul>
              </div>
              <button v-else ref="location" @click="showLocations = !showLocations"> {{ selectedLocation }}</button>
            </div>
          </div>
          <div class="modal-create-data-item">
            <p>Vehicle Type</p>
            <div>
              <div v-if="showResidents">
                <ul @mouseleave="showResidents = false">
                  <li v-for="resident in residents" :key="resident.uid" @click="setSelectedResident(resident)">
                    {{ `${resident.first_name} ${resident.last_name} (${resident.subdivision})` }}
                  </li>
                </ul>
              </div>
              <button v-else ref="resident" @click="showResidents = !showResidents"> {{
                getSelectedResidentText() }}</button>
            </div>
          </div>
          <div class="modal-create-data-item">
            <p>Vehicle Year</p>
            <div>
              <div v-if="showResidents">
                <ul @mouseleave="showResidents = false">
                  <li v-for="resident in residents" :key="resident.uid" @click="setSelectedResident(resident)">
                    {{ `${resident.first_name} ${resident.last_name} (${resident.subdivision})` }}
                  </li>
                </ul>
              </div>
              <button v-else ref="resident" @click="showResidents = !showResidents"> {{
                getSelectedResidentText() }}</button>
            </div>
          </div>
          <div class="modal-create-data-item">
            <p>Vehicle Color</p>
            <div>
              <div v-if="showResidents">
                <ul @mouseleave="showResidents = false">
                  <li v-for="resident in residents" :key="resident.uid" @click="setSelectedResident(resident)">
                    {{ `${resident.first_name} ${resident.last_name} (${resident.subdivision})` }}
                  </li>
                </ul>
              </div>
              <button v-else ref="resident" @click="showResidents = !showResidents"> {{
                getSelectedResidentText() }}</button>
            </div>
          </div>
          <div class="modal-create-data-item">
            <p>License Plate Number</p>
            <textarea ref="notes" type="text" placeholder="" maxlength="200" rows="5" v-model="comments"></textarea>
          </div>
          <div class="modal-create-data-item">
            <p>Transponder Number</p>
            <div>
              <div v-if="showResidents">
                <ul @mouseleave="showResidents = false">
                  <li v-for="resident in residents" :key="resident.uid" @click="setSelectedResident(resident)">
                    {{ `${resident.first_name} ${resident.last_name} (${resident.subdivision})` }}
                  </li>
                </ul>
              </div>
              <button v-else ref="resident" @click="showResidents = !showResidents"> {{
                getSelectedResidentText() }}</button>
            </div>
          </div>
          <div class="modal-create-data-item">
            <p>Decal Number</p>
            <div>
              <div v-if="showResidents">
                <ul @mouseleave="showResidents = false">
                  <li v-for="resident in residents" :key="resident.uid" @click="setSelectedResident(resident)">
                    {{ `${resident.first_name} ${resident.last_name} (${resident.subdivision})` }}
                  </li>
                </ul>
              </div>
              <button v-else ref="resident" @click="showResidents = !showResidents"> {{
                getSelectedResidentText() }}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button @click="createVehicle()">Create Vehicle</button>
      </div>
    </div>
  </modal>
</template>

<script>
import * as Constants from "../../js/constants.js";

const NAME = Constants.CREATE_VEHICLE_MODAL

export default {
  modalName: NAME,
  components: {
  },
  opened(event) {
    console.log('Opening...', event)
  },
  watch: {
    title(newValue) {
      if (newValue != "") this.$refs['title'].classList.remove('invalid')
    },
    description(newValue) {
      if (newValue != "") this.$refs['description'].classList.remove('invalid')
    },
  },
  data() {
    return {
      modalName: NAME,
      firstName: "",
      lastName: "",
      title: "",
      description: "",
      notes: "",
      comments: "",
      sendNotifications: false,
      locationRef: this.$refs.location,
      selectedLocation: "",
      showLocations: false,
      locations: [
        "Clubhouse",
        "Front Gate",
        "Back Gate",
        "Pool",
        "Basketball Court",
        "Tennis Court"
      ],
      selectedType: "",
      showTypes: false,
      types: [
        "Tresspassing",
        "Robbery",
        "Vehicle",
        "Assault"
      ],
      selectedPriority: "",
      showPriorities: false,
      priorities: [
        "Urgent",
        "High",
        "Medium",
        "Low"
      ],
      selectedStatus: "",
      showStatuses: false,
      statuses: [
        "OPEN",
        "IN PROGRESS",
        "BLOCKED",
        "CLOSED"
      ],
      currentVehicle: {
        "uid": "fa9c6911-44e8-4cf6-9cfd-96b089c95be9",
        "first_name": "Richard",
        "last_name": "Dale (Guard)",
        "address": "16303 SW 39th St Miramar FL, 33027",
        "primary_email_address": "richard@communitylp.com",
        "secondary_email_address": "",
        "primary_phone_number": "+19548052619",
        "secondary_phone_number": "",
        "primary_account": 1,
        "primary_account_id": "fa9c6911-44e8-4cf6-9cfd-96b089c95be9",
        "security_question": "Dog's Name",
        "security_question_answer": "Memo",
        "lifesaving_equipment": "N/A",
        "mobility_assistance": "N/A",
        "subdivision": "Marina Isle",
        "role": "resident",
        "notification_token": ""
      },
      showResidents: false,
      residents: [
        {
          "uid": "618a1a95-4795-4473-bf56-4e115e5c6aaa",
          "first_name": "Richard",
          "last_name": "Dale",
          "address": "16707 SW 39th St Miramar FL, 33027",
          "primary_email_address": "richard@communitylp.com",
          "secondary_email_address": "",
          "primary_phone_number": "+19548052619",
          "secondary_phone_number": "",
          "primary_account": 1,
          "primary_account_id": "618a1a95-4795-4473-bf56-4e115e5c6aaa",
          "security_question": "Dog's Name",
          "security_question_answer": "Memo",
          "lifesaving_equipment": "N/A",
          "mobility_assistance": "N/A",
          "subdivision": "Fantasy Isle",
          "role": "resident",
          "notification_token": ""
        },
        {
          "uid": "835d1084-d9a4-46d2-947b-f790b3d7ab3c",
          "first_name": "Richard",
          "last_name": "Dale",
          "address": "16707 SW 39th St Miramar FL, 33027",
          "primary_email_address": "richard@communitylp.com",
          "secondary_email_address": "",
          "primary_phone_number": "+19548052619",
          "secondary_phone_number": "",
          "primary_account": 1,
          "primary_account_id": "835d1084-d9a4-46d2-947b-f790b3d7ab3c",
          "security_question": "Dog's Name",
          "security_question_answer": "Memo",
          "lifesaving_equipment": "N/A",
          "mobility_assistance": "N/A",
          "subdivision": "Fantasy Isle",
          "role": "resident",
          "notification_token": ""
        },
        {
          "uid": "fa9c6911-44e8-4cf6-9cfd-96b089c95be9",
          "first_name": "Richard",
          "last_name": "Dale",
          "address": "16303 SW 39th St Miramar FL, 33027",
          "primary_email_address": "richard@communitylp.com",
          "secondary_email_address": "",
          "primary_phone_number": "+19548052619",
          "secondary_phone_number": "",
          "primary_account": 1,
          "primary_account_id": "fa9c6911-44e8-4cf6-9cfd-96b089c95be9",
          "security_question": "Dog's Name",
          "security_question_answer": "Memo",
          "lifesaving_equipment": "N/A",
          "mobility_assistance": "N/A",
          "subdivision": "Marina Isle",
          "role": "resident",
          "notification_token": ""
        }
      ],
      selectedResident: null,
      selectedAssignee: null,
      showAssignees: false
    }
  },
  methods: {
    show() {
      this.$modal.show(NAME);
    },
    beforeOpen(event) {
      console.log('Before Opening...', event)
      this.fetchLocations()

    },
    validateKey() {
      console.log("Validating key...")
    },
    close() {
      this.$modal.hide(NAME);
    },
    getReporterText() {
      return `${this.currentVehicle.first_name} ${this.currentVehicle.last_name}`
    },
    setLocation(location) {
      this.selectedLocation = location;
      this.showLocations = false;
      this.$refs['location'].classList.remove('invalid')
    },
    setType(type) {
      this.selectedType = type;
      this.showTypes = false;
      this.$refs['type'].classList.remove('invalid')
    },
    setPriority(priority) {
      this.selectedPriority = priority;
      this.showPriorities = false;
      this.$refs['priority'].classList.remove('invalid')
    },
    setStatus(status) {
      this.selectedStatus = status;
      this.showStatuses = false;
      this.$refs['status'].classList.remove('invalid')
    },
    setSelectedResident(resident) {
      this.selectedResident = resident;
      this.showResidents = false;
      this.$refs['resident'].classList.remove('invalid')
    },
    setAssignee(vehicle) {
      this.selectedAssignee = vehicle;
      this.showAssignees = false;
      this.$refs['assignee'].classList.remove('invalid')
    },
    getSelectedResidentText() {
      if (this.selectedResident === null) return ""
      else return `${this.selectedResident.first_name} ${this.selectedResident.last_name} (${this.selectedResident.subdivision})`
    },
    getSelectedAssigneeText() {
      if (this.selectedAssignee === null) return ""
      else return `${this.selectedAssignee.first_name} ${this.selectedAssignee.last_name}`
    },
    inputsValid() {
      let selectedResidentVerified = this.selectedResident != null;
      let selectedTypeVerified = this.selectedType != "";
      let selectedTitleVerified = this.title != "";
      let selectedDescriptionVerified = this.description != "";
      let selecetdReporterVerified = this.currentVehicle != null;
      let selecetdStatusVerified = this.selectedStatus != "";
      let selecetdPriorityVerified = this.selectedPriority != "";
      let selecetdLocationVerified = this.selectedLocation != "";
      let selectedAssigneeVerified = this.selectedAssignee != null;
      let warnings = []

      if (!selectedTitleVerified) {
        warnings.push("Input a title for this vehicle")
        this.$refs['title'].classList.add('invalid')
      }
      if (!selectedDescriptionVerified) {
        warnings.push("Input a description for this vehicle")
        this.$refs['description'].classList.add('invalid')
      }
      if (!selecetdLocationVerified) {
        warnings.push("Select a location for the vehicle")
        console.log("Location Ref", this.$refs['location'])
        this.$refs['location'].classList.add('invalid')
      }
      if (!selecetdReporterVerified) {
        warnings.push("Sign in to Create an Vehicle")
      }
      if (!selectedTypeVerified) {
        warnings.push("Select a type for the vehicle")
        this.$refs['type'].classList.add('invalid')
      }
      if (!selecetdStatusVerified) {
        warnings.push("Select a status for the vehicle")
        this.$refs['status'].classList.add('invalid')
      }
      if (!selecetdPriorityVerified) {
        warnings.push("Select a priority for the vehicle")
        this.$refs['priority'].classList.add('invalid')
      }
      if (!selectedResidentVerified) {
        warnings.push("Select an associated Resident")
        this.$refs['resident'].classList.add('invalid')
      }
      if (!selectedAssigneeVerified) {
        warnings.push("Select an Assignee")
        this.$refs['assignee'].classList.add('invalid')
      }

      if (warnings.length != 0) {
        alert(warnings.join('\n'))
        return false
      }
      return true
    },
    fetchLocations() {
      let url = `https://ufgow7hy1f.execute-api.us-east-2.amazonaws.com/dev/nautica2/locations`
      return new Promise((resolve, reject) => {
        fetch(
          url,
          {
            method: `GET`,
            headers: {
              "Content-Type": "application/json",
            }
          }
        )
          .then((res) => res.json())
          .then((data) => {
            console.log("CREATE Vehicle - Location Data", data);
            this.locations = data.data
            resolve(data.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    createVehicle() {
      console.log(this.$data)

      if (!this.inputsValid()) {
        return;
      }

      let url = `https://2r7ags60v2.execute-api.us-east-2.amazonaws.com/stage/nautica2/vehicles`
      return new Promise((resolve, reject) => {
        fetch(
          url,
          {
            method: `POST`,
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              "resident_uid": this.selectedResident.uid,
              "vehicle_type": this.selectedType,
              "vehicle_title": this.title,
              "description": this.description,
              "reporter": this.currentVehicle.uid,
              "current_status": this.selectedStatus,
              "priority": this.selectedPriority,
              "location": this.selectedLocation
            })
          }
        )
          .then((res) => res.json())
          .then((data) => {
            console.log("Search Data", data);
            this.close()
            resolve(data.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    handleUploadAttachments() {
      alert("Upload Attachments")
    }
  },
  created() {
    console.log("In modal")
    console.log("Create Vehicle Modal Params", this.$$props)
  },
}
</script>

<style scoped>
.modal-container {
  display: flex;
  flex-direction: column;
  background-color: #699991;
  color: white;
  border-radius: 4px;
}

.modal-create-data-item input {
  flex: 1;
  height: 100%;
  width: 100%;
  font-size: 14px;
  outline: 0;
  border: 0;
  text-align: center;
}

.visitor-modal-title::placeholder {
  color: black;
}

.validate-button {
  color: white;
  background-color: #87BAB7;
  width: 60%;
  margin-left: auto;
  margin-right: auto;
  height: 2rem;
  border-radius: 5px;
  margin-top: .5rem;
  margin-bottom: .5rem;
}

.modal-field {
  padding: 1rem;
  font-size: 25px;
  border-bottom: 1px solid #87BAB7;
}

.modal-time-info {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}

.modal-time-inner {
  display: flex;
  flex-direction: column;
  padding: 1rem;
  border-right: 1px solid #87BAB7;
  border-left: 1px solid #87BAB7;
}

.helper-text {
  text-align: left;
  font-size: 15px;
}

.circle {
  width: 160px;
  height: 160px;
  line-height: 160px;
  border-radius: 50%;
  font-size: 50px;
  color: #fff;
  text-align: center;
  background: #87BAB7;
}

.resident-search-bar {
  display: flex;
  width: 100%;
  height: 100%;
  font-size: 12px !important;
  background-color: #F3F3F3;
  align-items: center;
  border-radius: 0px;
  border: 0;
}

.resident-search-bar::placeholder {
  color: black;
}

.resident-search-bar input {
  background-color: white;
  text-align: center;
}

.modal-header {
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  border-radius: 4px;
  color: black;
  border: 1px solid black;
}

.modal-header h3 {
  font-size: 36px;
}

.modal-content {
  padding: 2rem;
}

.modal-intro-information {
  display: flex;
  flex-direction: column;
}

.modal-intro-information p {
  color: black;
  text-align: left;
}

.modal-intro-information label {
  color: black;
  text-align: left;
  text-decoration: underline;
}

.modal-vehicle-title {
  font-size: 24px;
  margin-bottom: 18px;
  border-bottom: 1px solid black;
  text-decoration: none;
  outline: 0;
}

.modal-vehicle-title::placeholder {
  color: #d9d9d988;
}

.modal-vehicle-description {
  font-size: 14px;
  font-weight: lighter;
  border-bottom: 1px solid black;
  text-decoration: none;
  outline: 0;
  margin-bottom: 18px;
  resize: none;

}

.modal-vehicle-description::placeholder {
  color: #d9d9d988;
}

.upload-attachment {}

.upload-attachment button {
  display: flex;
  flex-direction: row;
  padding: 8px;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background-color: #d9d9d9dd;
  color: black
}

.modal-dropdown-button {
  color: black;
  background-color: #d9d9d9;
  padding: 4px 8px;
  margin-right: 10px;
  border: 1px solid black;
  border-radius: 4px;
}

.modal-create-data {
  margin-top: 41px;
  display: flex;
  flex-direction: column;
}

.modal-create-data-item {
  display: flex;
  flex-direction: row;
  color: black;
  border: 1px solid black;
  height: 36px;
  border-radius: 4px;
}

.modal-create-data-item input {
  flex: 1;
  background-color: #d9d9d9;
  text-align: center;
}

.modal-create-data-item p {
  align-content: center;
  text-align: left;
  font-weight: bold;
  flex: 1;
  padding-left: 8px;
  border-right: 1px solid black;
}

.modal-create-data-item textarea {
  align-content: center;
  text-align: left;
  font-weight: bold;
  flex: 1;
  height: 100%;
  resize: none;
  font-size: 14px;
  font-weight: lighter;
  outline: 0px;
  background-color: #d9d9d9dd;
}

.modal-create-data-item div {
  flex: 1;
  background-color: #d9d9d9;
}

.modal-create-data-item button {
  flex: 1;
  width: 100%;
  height: 100%;
  background-color: #ccd9d9d9;
}

.modal-create-data-item div ul {
  height: 100%;
}

.modal-create-data-item div li {
  position: relative;
  flex: 1;
  list-style: none;
  text-decoration: none;
  background-color: white;
  text-align: center;
  height: 100%;
  align-items: center;
  justify-content: center;
  z-index: 2;
  border-bottom: 1px solid #ccd9d9d9;

}

.modal-create-data-item div li:hover {
  background-color: #699991;
}

.invalid {
  outline: 1px solid red;
}

.modal-footer {
  padding: 1rem;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  border-radius: 4px;
  color: black;
  border: 1px solid black;
}

.toggle-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.toggle-container p {
  margin-left: 8px;
}

.modal-footer button {
  background-color: #699991;
  padding: 4px 24px;
  border-radius: 4px;
  border: 1px solid black;
  font-weight: bold;

}
</style>